export default __webpack_public_path__ + "static/media/point-of-sale.1db62a2a.svg";